<div class="flex justify-content-end language-switcher">
  <p-selectButton
    name="languageSwitcher-selectbtn"
    [options]="stateOptions"
    [(ngModel)]="selectedLocale"
    optionLabel="label"
    optionValue="value"
    (ngModelChange)="setLocale($event)"></p-selectButton>
</div>
